import { FONT_WEIGHT_OPTIONS, sizeTokenOptions, sizeTokenOptionsWithDefault, TITLE_LEVEL_OPTIONS, UI_FIELD_DEFAULT_OPTION, } from './token-options.js';
export const APP_BAR_FIELDS = [
    {
        key: 'appBar.minHeight',
        label: '높이',
        help: '화면 맨 위 상단 바(뒤로 가기·제목이 있는 줄)의 최소 높이입니다. 기본은 지금 높이(앱 49px · 모바일 웹 56px)입니다.',
        group: '크기·여백',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: [
            { value: UI_FIELD_DEFAULT_OPTION, label: '기본 (앱 49px · 모바일 웹 56px)' },
            ...sizeTokenOptions('dimension').filter((option) => ['l-plus', 'xl', 'xl-plus', '2xl', '2xl-plus', '3xl'].includes(option.value)),
        ],
    },
    {
        key: 'appBar.paddingX',
        label: '좌우 여백',
        help: '상단 바 양 끝과 뒤로 가기 버튼·오른쪽 버튼 사이의 여백입니다. 기본은 지금 여백(앱 14px · 모바일 웹 16px)입니다.',
        group: '크기·여백',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '앱 14px · 모바일 웹 16px'),
    },
    {
        key: 'appBar.paddingY',
        label: '위아래 여백',
        help: '상단 바 안쪽 위아래 여백입니다. 기본은 지금 여백(앱 7px · 모바일 웹 8px)입니다.',
        group: '크기·여백',
        type: 'enum',
        defaultValue: UI_FIELD_DEFAULT_OPTION,
        options: sizeTokenOptionsWithDefault('spacing', '앱 7px · 모바일 웹 8px'),
    },
    {
        key: 'appBar.title.level',
        label: '제목 글자 크기',
        help: '상단 바 가운데(또는 왼쪽) 화면 제목의 글자 크기입니다.',
        group: '제목',
        type: 'enum',
        defaultValue: '3',
        options: TITLE_LEVEL_OPTIONS,
    },
    {
        key: 'appBar.title.weight',
        label: '제목 굵기',
        help: '상단 바 화면 제목의 글자 굵기입니다.',
        group: '제목',
        type: 'enum',
        defaultValue: 'bold',
        options: FONT_WEIGHT_OPTIONS,
    },
    {
        key: 'appBar.icon.size',
        label: '뒤로 가기 아이콘 크기',
        help: '상단 바 왼쪽 뒤로 가기(또는 닫기) 아이콘의 크기입니다. 누를 수 있는 영역은 48px 그대로입니다.',
        group: '아이콘',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: '$dimension.s',
        min: 12,
        max: 40,
    },
];
//# sourceMappingURL=appBar.js.map